enum FundTransactionType {
  REDEMPTION = 'REDEMPTION',
  PURCHASE = 'PURCHASE',
  SWITCH_PURCHASE = 'SWITCH_PURCHASE',
  SWITCH_REDEMPTION = 'SWITCH_REDEMPTION',
  EVENT_PURCHASE = 'EVENT_PURCHASE',
  EVENT_REDEMPTION = 'EVENT_REDEMPTION',
  SWITCH_FUND_ACCOUNTS_PURCHASE = 'SWITCH_FUND_ACCOUNTS_PURCHASE',
  SWITCH_FUND_ACCOUNTS_REDEMPTION = 'SWITCH_FUND_ACCOUNTS_REDEMPTION',
  SAVINGSAGREEMENT = 'SAVINGSAGREEMENT',
  ASK_MOVE_OUT = 'ASK_MOVE_OUT',
  ASK_MOVE_IN = 'ASK_MOVE_IN',
  IPS_MOVE_IN = 'IPS_MOVE_IN',
  IPS_MOVE_OUT = 'IPS_MOVE_OUT',
  PAYMENT_AGREEMENT = 'PAYMENT_AGREEMENT',
  DIVIDEND_PURCHASE = 'DIVIDEND_PURCHASE',
  DIVIDEND_REDEMPTION = 'DIVIDEND_REDEMPTION',
  UNKNOWN = 'UNKNOWN',
}

export default FundTransactionType;
